import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";

import {useConfig} from '../ConfigProvider';
import { useTunnelData } from "../TunnelContext";
import StepsDisplay from "../StepsDisplay";
import Loader from "../Loader";
import Api from "../baseApi";
import Button from "../Button";
import SignatureModal from './SignatureModal';
import StyledStepFooter from '../StyledStepFooter';
import { useTurnstile, TurnstilePendingError } from "../hooks/useTurnstile";
import './Contract.scss';

export default function Contract(){
  const config = useConfig();
  const { tunnel, setTunnel } = useTunnelData();
  const [ contract, setContract ] = useState(false);
  const [ error, setError ] = useState(false);
  const [ step, setStep ] = useState("CONTRACT");
  // Chaque envoi ou renvoi de SMS de signature exige son propre jeton Turnstile (MSDS-1143).
  const captcha = useTurnstile(config.turnstile?.siteKey);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (!tunnel.club || !tunnel.sales) return ;

    setError(false);
    const [ query ] = Api.GET({
      path: '/api/vel/resamania2/contracts',
			options: {
				blob: true
			},
      query: {
        tunnelUid: tunnel.uid,
        msdsId: tunnel.club.msdsId,
				saleId: tunnel.sales['@id']
      }
    });

    query.then((blob) => {
			const pdfUrl = URL.createObjectURL(blob);
			setContract(pdfUrl)
		})
    .catch( e=> {
      console.error(e);
      setError('Nous ne pouvons afficher le contrat')
    });

  }, [ tunnel.sales, tunnel.club, tunnel.uid ]);

  const sendSms = async () => {
    if (captcha.enabled && !captcha.token) throw new TurnstilePendingError();

    const [ query ] = Api.POST({
      path: '/api/vel/resamania2/sign_mandates',
      body: {
        tunnelUid: tunnel.uid,
        msdsId: tunnel.club.msdsId,
        signMandate: {
          mandateId: tunnel.mandate['id'],
          email: tunnel.user?.email,
          saleId: tunnel.sales['@id'],
        }
      },
      headers: captcha.headers,
    });
    captcha.reset();
    return query;
  };

  const askToSign = (e) => {
    e.preventDefault();

    setStep("SMS");
    setError(false);

    return sendSms()
    .then( ret => {
      setTunnel({ ...tunnel, sign_request: ret });
      setStep("SIGNMODAL");
    })
    .catch( e => {
      console.error(e);
      setError(e instanceof TurnstilePendingError ? e.message : "Problème d'envoi SMS");
      setStep("CONTRACT");
    })
  };

  if (!tunnel.club || !tunnel.sales) return <Redirect push to={'/'} />;


  if (step === "SMS")
    return <Loader text={config.loadingSmsCodeSend} />;

  if( step === "SIGNMODAL" ) {
    return (
      <main className="Contract">
        <StepsDisplay step="Contrat"/>
        <SignatureModal sendSMSMethod={sendSms} />
      </main>
    );
  }

  return (
    <main className="Contract">
      <StepsDisplay step="Contrat"/>
      <header>
        <h2>{config.contract.title}</h2>
      </header>
      {!!contract ?
        <section>
          <iframe title={config.contract.title} src={contract} />
        </section>
        :
        <Loader/>
      }
      <StyledStepFooter>
        {error && <p style={{color:"red"}}>{error}</p>}
        <Button variant='primary' className="btn-primary" onClick={askToSign}>{config.contract.signLabel}</Button>
      </StyledStepFooter>
    </main>
  );
}
